import { useTranslation } from 'react-i18next';

const partners = [
  { cls: 'w-[95px] h-[31px] lg:w-[135px] lg:h-[44px]' },
  { cls: 'w-[90px] h-[31px] lg:w-[128px] lg:h-[44px]' },
  { cls: 'w-[148px] h-[31px] lg:w-[211px] lg:h-[44px]' },
  { cls: 'w-[66px] h-[31px] lg:w-[94px] lg:h-[44px]' },
  { cls: 'w-[95px] h-[31px] lg:w-[135px] lg:h-[44px]' },
  { cls: 'w-[95px] h-[31px] lg:w-[135px] lg:h-[44px]' },
  { cls: 'w-[98px] h-[31px] lg:w-[140px] lg:h-[44px]' },
  { cls: 'w-[99px] h-[31px] lg:w-[141px] lg:h-[44px]' },
];

const Partners = () => {
  const { t } = useTranslation();
  return (
    <div className="pb-4  mt-2  dark:border-none border-b border-black">
      <h3 className="text-[15px] sm:text-[19px] font-medium text-[#1F2C38] dark:text-white mb-1 sm:mb-3">
        {t('footer.partners')}
      </h3>
      <div className="flex items-center justify-center gap-3 overflow-x-auto scrollbar-hide flex-wrap bg-white py-0 sm:py-3">
        {partners.map((partner, i) => (
          <img
            key={i}
            src={`/images/casino/partner${i + 1}.png`}
            alt={`partner ${i + 1}`}
            className={`object-contain flex-shrink-0 ${partner.cls}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Partners;
